/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideIcon24Solid = forwardRef('DivideIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M2 12.5A1.5 1.5 0 0 1 3.5 11h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 12.5Z" }),
        React.createElement("path", { d: "M12 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
